/* <bodi-lightbox> — click a .bps-thumb[data-full] to open a full-screen
   zoomable image. Prev/next + keyboard nav; click image to zoom (origin
   follows the cursor); backdrop / × / Esc to close. */
(function () {
  if (customElements.get('bodi-lightbox')) return;

  class BodiLightbox extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.bps-thumb[data-full]'));
      if (!this.thumbs.length) return;
      this.items = this.thumbs.map((t) => ({
        full: t.dataset.full,
        alt: (t.querySelector('img') && t.querySelector('img').alt) || '',
      }));
      this._build();
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this._open(i)));
    }

    _build() {
      const m = document.createElement('div');
      m.className = 'bps-lb';
      m.hidden = true;
      m.innerHTML =
        '<button type="button" class="bps-lb-close" aria-label="Close">&times;</button>' +
        '<button type="button" class="bps-lb-nav bps-lb-prev" aria-label="Previous">&lsaquo;</button>' +
        '<div class="bps-lb-stage" data-stage><img class="bps-lb-img" data-img alt=""></div>' +
        '<button type="button" class="bps-lb-nav bps-lb-next" aria-label="Next">&rsaquo;</button>';
      document.body.appendChild(m);
      this.modal = m;
      this.img = m.querySelector('[data-img]');
      this.stage = m.querySelector('[data-stage]');

      m.querySelector('.bps-lb-close').addEventListener('click', () => this._close());
      m.querySelector('.bps-lb-prev').addEventListener('click', () => this._go(-1));
      m.querySelector('.bps-lb-next').addEventListener('click', () => this._go(1));
      m.addEventListener('click', (e) => { if (e.target === m || e.target === this.stage) this._close(); });
      this.img.addEventListener('click', (e) => { e.stopPropagation(); this._toggleZoom(e); });
      this.stage.addEventListener('mousemove', (e) => this._pan(e));

      this._onKey = (e) => {
        if (e.key === 'Escape') this._close();
        else if (e.key === 'ArrowLeft') this._go(-1);
        else if (e.key === 'ArrowRight') this._go(1);
      };

      const single = this.items.length < 2;
      m.querySelector('.bps-lb-prev').hidden = single;
      m.querySelector('.bps-lb-next').hidden = single;
    }

    _open(i) {
      this.index = i;
      this._set();
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
    }

    _close() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      this._unzoom();
      document.removeEventListener('keydown', this._onKey);
    }

    _go(d) {
      this._unzoom();
      this.index = (this.index + d + this.items.length) % this.items.length;
      this._set();
    }

    _set() {
      const it = this.items[this.index];
      this.img.src = it.full;
      this.img.alt = it.alt;
    }

    _toggleZoom(e) {
      const zoomed = this.img.classList.toggle('is-zoomed');
      if (zoomed) this._pan(e);
      else this.img.style.transformOrigin = '';
    }

    _unzoom() {
      this.img.classList.remove('is-zoomed');
      this.img.style.transformOrigin = '';
    }

    _pan(e) {
      if (!this.img.classList.contains('is-zoomed')) return;
      const r = this.img.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      this.img.style.transformOrigin = x + '% ' + y + '%';
    }
  }

  customElements.define('bodi-lightbox', BodiLightbox);
})();
